import { ProgressData } from 'core/Components';
import { Grid, Group, Skeleton, Stack, Text } from 'ui';
import { IconClock, IconProfile } from 'ui/Icons';

import { useGetHolidayPromotion } from '../api';

const RaisedSoFar = () => {
  const { data, isLoading } = useGetHolidayPromotion();

  return (
    <Skeleton visible={isLoading}>
      <Stack miw={{ base: 'auto', md: '350px' }}>
        <ProgressData
          size={'lg'}
          goal={data?.goal}
          amount_raised={data?.raised_so_far || 0}
          amount_pledged={0}
          removeTrailingCents={true}
        />
        <Grid>
          <Grid.Col span={6}>
            <Group gap={'xs'} align={'center'}>
              <IconProfile size="16px" color={'gray.8'} />
              <Text size="xs">{data?.count_of_action} actions taken</Text>
            </Group>
          </Grid.Col>

          <Grid.Col span={6}>
            <Group gap={'xs'} align={'center'}>
              <IconClock size="16px" color={'gray.8'} />
              <Text size="xs">{data?.days_left} days left</Text>
            </Group>
          </Grid.Col>
        </Grid>
      </Stack>
    </Skeleton>
  );
};

export { RaisedSoFar };
